import { giveawayModuleIds } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds';
export const giveawayTermsConditionModalModule = {
    [giveawayModuleIds.GIVEAWAY_TERMS_CONDITION_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
